import { Visibility, VisibilityOff } from "@mui/icons-material";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import React, { useState } from "react";


export default function Input(props) {
  const { name, label, value, error = null, onChange, type, ...other } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  // Render for file input
  if (type === "file") {
    return (
      <input
        accept="image/*"
        type="file"
        name={name}
        onChange={onChange}
        {...other}
      />
    );
  }

  return (
    <TextField
      variant="outlined"
      label={label}
      name={name}
      type={
        type === "number"
          ? "number"
          : type === "password" && !showPassword
          ? "password"
          : "text"
      }
      value={value}
      onChange={onChange}
      autoFocus
      {...other}
      {...(error && { error: true, helperText: error })}
      InputProps={{
        endAdornment:
          type === "password" ? (
            <InputAdornment position="end">
              <IconButton onClick={handleClickShowPassword} edge="end">
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : null,
      }}
    />
  );
}
